export const types = {
    // Sync
    SET_PRODUCTS: "SET_PRODUCTS",
    SET_PRODUCT: "SET_PRODUCT",
    SET_PRODUCT_ATTRIBUTES: "SET_PRODUCT_ATTRIBUTES",
    SET_PRODUCT_REVIEWS: "SET_PRODUCT_REVIEWS",
    SET_SEARCH: "SET_SEARCH",
    CLEAN_PRODUCT: "CLEAN_PRODUCT",
    CLEAN_PRODUCTS: "CLEAN_PRODUCTS",
    UPDATE_PAGE_COUNT: "UPDATE_PAGE_COUNT",

    CLEAN_SELECTED_ITEMS: "CLEAN_SELECTED_ITEMS",

    // Async    
    FETCH_PRODUCTS_ASYNC: "FETCH_PRODUCTS_ASYNC",
    FETCH_PRODUCT_ASYNC: "FETCH_PRODUCT_ASYNC",
    SEARCH_ASYNC: "SEARCH_ASYNC",
};
